<template>
    <div>
        <div class="h-54 px-2 flex items-center bg-bd">
            <div>
                <img class="w-50 h-50" src="../assets/logo.jpg" alt="">
            </div>
            <div class="w-[100%] text-center text-34 font-medium  text-primary">
                南邓字花
            </div>
        </div>
    </div>
</template>
<script>
export default{

}
</script>
<style scoped>
</style>